<template>
  <div class="tnb">
    <div class="tnb-util-container">
      <div class="language-selector">
        <div class="language-display" @click="langToggle">
          <svg
            class="lang-icon"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.00023 11.9986C9.06877 15.0735 10.1263 18.0338 12 20.4478C13.8737 18.0338 14.9312 15.0735 14.9998 11.9986C14.9312 8.9238 13.8737 5.96349 12 3.54944C10.1263 5.96349 9.06877 8.9238 9.00023 11.9986ZM12 1.99864L11.2617 1.32422C8.59689 4.24155 7.08251 8.0275 7.00022 11.9778C6.99993 11.9917 6.99993 12.0056 7.00022 12.0195C7.08251 15.9698 8.59689 19.7557 11.2617 22.6731C11.4511 22.8805 11.7191 22.9986 12 22.9986C12.2809 22.9986 12.5489 22.8805 12.7383 22.6731C15.4031 19.7557 16.9175 15.9698 16.9998 12.0195C17.0001 12.0056 17.0001 11.9917 16.9998 11.9778C16.9175 8.0275 15.4031 4.24155 12.7383 1.32422L12 1.99864Z"
              fill="white"
            />
          </svg>
          language
          <span class="arrow" :class="{ open: isalangVisible }">▼</span>
        </div>
        <ul v-if="isalangVisible" class="language-options">
          <li @click="selectLanguage('한국어')">한국어</li>
          <li @click="selectLanguage('ENG')">ENG</li>
          <li @click="selectLanguage('中国')">中国</li>
        </ul>
      </div>
      <router-link to="/auth" @click="handleClearNav">
        <svg
          class="user-icon"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2044 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z"
          />
        </svg>
      </router-link>

      <router-link to="/search" @click="handleClearNav">
        <svg
          class="search-icon"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9433 15.9413C16.3338 15.5508 16.967 15.5508 17.3575 15.9413L21.7075 20.2913C22.098 20.6819 22.098 21.315 21.7075 21.7055C21.317 22.0961 20.6838 22.0961 20.2933 21.7055L15.9433 17.3555C15.5528 16.965 15.5528 16.3319 15.9433 15.9413Z"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clearNav: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isalangVisible: false,
    };
  },
  methods: {
    langToggle() {
      this.isalangVisible = !this.isalangVisible;
    },
    selectLanguage(language) {
      console.log(`Selected language: ${language}`);
      this.isalangVisible = false;
    },
    handleClearNav() {
      if (this.clearNav) {
        this.clearNav(); // clearNav 호출
      }
    },
  },
};
</script>

<style>
@import "../assets/css/tnb/tnb.css";
</style>
